import { INirsham } from './../nofesh/model/nirsham';
import { INofeshTashlumim } from './../nofesh/model/nofesh-tashlumim';
import { INofeshUploads } from './../nofesh/model/nofesh-uploads';
import { INofshonPayment } from './model/nofshon-payment';
import { INofshonNirshamim } from './model/nofshon-nirshamim';
import { AppSettings } from './../shared/app-settings';
import { IHerkevHazmana } from './model/herkev-hazmana';
import { Injectable } from '@angular/core';
import { HttpService } from './../shared/http.service';
import { BehaviorSubject, Observable, Subject } from '../../../node_modules/rxjs';
import { Http, Response, URLSearchParams } from '@angular/http';
import { INofshonNirsham } from './model/nofshon-nirsham';
import { ISummaryRequest } from './model/summary-request';
import { IAddTashlum } from './model/IAddTashlum';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { tap } from 'rxjs/operators';
import { ResultOfOperation } from '../shared/model/result-of-operation.model';
import { ConfigService } from 'app/shared/config.service';
import { IOrderNofshonSubmitRequest } from './interfaces/iorder-nofshon-submit-request.interface';
import { IOrderNofshonSubmitResponse } from './interfaces/iorder-nofshon-submit-response.interface';
import { INofshonPriceType } from 'app/shared/interfaces/nofshon-price-type.interface';
import { IHerkevHazmanaNofeshPnim } from './model/herkev-hazmana-nofesh-pnim.interface';
import { IOrderNofshonSubmitRequestNofeshPnim } from './interfaces/iorder-nofshon-submit-request-nofesh-pnim.interface';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { INofeshSelected, NofeshSelected } from 'app/shared/interfaces/Inofesh-selected.interface';
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';



@Injectable()
export class NofshonimService {
    apiUrl: string = "";

    private _homePageHasTimerSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    homePageHasTimer$: Observable<boolean> = this._homePageHasTimerSubject.asObservable();



    private _homePageTimerTimeoutSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    homePageTimerTimeout$: Observable<boolean> = this._homePageTimerTimeoutSubject.asObservable();


    constructor(
        private _http: HttpService,
        private _httpClient: HttpClient,
        private _spinnerService: SpinnerService,
        private _configService: ConfigService
    ) {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
    }

    shouldDisplayTimer(userSelectedNofesh: INofeshSelected): boolean {
        if (!userSelectedNofesh) return false;

        return userSelectedNofesh.nofesh_type === ENofeshType.NofeshPnim ||
            userSelectedNofesh.nofesh_type === ENofeshType.MeurganimPnim ||
            userSelectedNofesh.nofesh_type === ENofeshType.NofeshChul ||
            userSelectedNofesh.nofesh_type === ENofeshType.MishpachotChul;
    }

    notifyHomePageHasTimer(): void {
        console.log("Nofshon service - notifying homepage has timer");
        this._homePageHasTimerSubject.next(true);
    }

    notifyHomePageTimerTimeout(): void {
        console.log("Nofshon service - notifying homepage timer is timeout");
        this._homePageTimerTimeoutSubject.next(true);
    }

    saveNofshonReservation(data: IOrderNofshonSubmitRequest): Observable<IOrderNofshonSubmitResponse> {
        this._spinnerService.showSpinner();
        return this._http.post(`${this.apiUrl}/api/Nofesh/SaveNofshonReservation`, JSON.stringify(data))
        .pipe(
                tap(response => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .map(res => res.json())
            .catch(this.handleError)
    }

    completeNofshonReservation(nofeshId: number, isHamtana: boolean, reservationId: number): Observable<ResultOfOperation<boolean>> {
        this._spinnerService.showSpinner();
        const headers = new HttpHeaders().set('Content-Type','application/json');
        return this._httpClient.post<ResultOfOperation<boolean>>(`${this.apiUrl}/api/Nofesh/CompleteNofshonReservation`,JSON.stringify({ nofeshId, isHamtana, reservationId }),{headers:headers})
            .pipe(
                tap(
                    (success) => { this._spinnerService.hideSpinner(); },
                    (error) => { this._spinnerService.hideSpinner(); }
                )
            );
    }
   
    saveNofshonReservationNofeshPnim(data: IOrderNofshonSubmitRequestNofeshPnim): Observable<IOrderNofshonSubmitResponse> {
        this._spinnerService.showSpinner();
        return this._httpClient.post(`${this.apiUrl}/api/Nofesh/SaveNofshonReservationNofeshPnim`, data)
            .pipe(
                tap((response: IOrderNofshonSubmitResponse) => {
                    this._spinnerService.hideSpinner();

                    if (!environment.production) console.log(response);
                },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .catch(this.handleError);
    }

    savePirteyNofshim(model: INofshonNirshamim): Observable<ResultOfOperation<object>> {
        return this._http.post(`${this.apiUrl}/api/Nofesh/SaveNofshonNirshamim`, JSON.stringify(model))
            .map(res => res.json())
            .catch(this.handleError)
    }

    getNofeshonSummaryData(model: ISummaryRequest) {
        var url = `${this.apiUrl}/IrgunOvdim.Api/api/NofeshonChul/GetSummaryByUserId`;
        return this._http.post(url, JSON.stringify(model))
            .map(res => res.json())
            .catch(this.handleError);
    }

    getNofshonTashlumim(): Observable<any> {
        // var url= "http://localhost:8090/IrgunOvdim.Api/api/NofeshonChul/GetTashlumim?nofeshId=81";
        return this._http.get(`${this.apiUrl}/api/Nofesh/GetNofshonTashlumim`)
            // return this._http.get(url)
            .map(res => res.json())
            .catch(this.handleError);
    }

    saveNofshonTashlumim(model: INofeshTashlumim): Observable<any> {
        this._spinnerService.showSpinner();
        return this._httpClient.post(`${this.apiUrl}/api/Nofesh/SaveNofshonTashlumim`, model)
            .pipe(
                tap(
                    success => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            );

    }


    AddOrUpdateTashlumim(model: IAddTashlum[]) {

        var url = `${this.apiUrl}/api/NofeshonChul/AddOrUpdateTashlumim`;
        return this._http.post(url, JSON.stringify(model))
            .map(res => res.json())
            .catch(this.handleError);
    }

    getPirteyNofshim(nofeshId: number): Observable<INofshonNirsham[]> {
        const headers = new HttpHeaders()
            .set("Content-Type", "application/json");
        const params = new HttpParams()
            .set('nofeshId', nofeshId.toString());

        return this._httpClient.get<INofshonNirsham[]>(`${this.apiUrl}/api/Nofesh/GetNofshonNirshamim`, { headers, params })
            .pipe(
                tap(response => {
                    if (!environment.production) console.log("nofshon service - getPirteyNofshim", response);
                }, error => console.log(error))
            );
    }


    getNofshonPayment(nofeshId: number): Observable<any> {
        const httpParams = new HttpParams()
            .set('nofeshId', nofeshId.toString());
        const url = `${this.apiUrl}/api/Nofesh/getNofshonPayment`;
        return this._httpClient.get<INofshonPayment>(url, { params: httpParams });
    }
    // getNofshonPayment(nofeshId: number): Observable<any> {
    //     const headers = new HttpHeaders()
    //         .set("Content-Type", "application/json");
    //     const httpParams = new HttpParams()
    //         .set('nofeshId', nofeshId.toString())

    //     const url = `${this.apiUrl}/api/Nofesh/getNofshonPayment`;
    //     return this._httpClient.get(url, { headers: headers, params: httpParams })
    //         .map((response: Response) => <INofshonPayment>response.json())
    //         .catch(this.handleError)
    //     // return this._http.get(`${this.apiUrl}/api/Nofesh/getNofshonPayment`)

    // }

    //zipi: for haeder panel
    getUserReservedNofashim(): Observable<INofeshSelected[]> {
        const headers = new HttpHeaders()
            .set("Content-Type", "application/json");

        const url = `${this.apiUrl}/api/Nofesh/getUserReservedNofashim`;
        return this._httpClient.get<INofeshSelected[]>(url, { headers: headers })
        // .map((response: Response) => <INofeshSelected[]>response.json())
        // .catch(this.handleError)
    }


    getNirshamDetails(msZehut: string): Observable<INirsham> {
        const httpParams = new HttpParams()
            .set("msZehut", msZehut)
            .set("isNofshon", "true");
        const url = `${this.apiUrl}/api/Nofesh/GetNirshamDetails`;
        return this._httpClient.get<INirsham>(url, { params: httpParams });
    }

    getNofshonQuotation(herkev_hazmana: IHerkevHazmana): Observable<INofshonPayment> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofesh_id', herkev_hazmana.nofesh_id.toString());
        params.set('ms_amitim', herkev_hazmana.ms_amit.toString());
        params.set('ms_nilvim', herkev_hazmana.ms_nilve.toString());
        params.set('ms_yeladim', herkev_hazmana.ms_yeladim.toString());
        params.set('ms_tinokot', herkev_hazmana.ms_tinokot.toString());
        this._spinnerService.showSpinner();
        return this._http.get(`${this.apiUrl}/api/Nofesh/GetNofshonQuotation`, { search: params })
            .pipe(
                tap(response => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .map((response: Response) => <INofshonPayment>response.json())
            .catch(this.handleError)
    }

    getNofshonQuotationOnly(herkev_hazmana: IHerkevHazmana): Observable<INofshonPayment> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofesh_id', herkev_hazmana.nofesh_id.toString());
        params.set('ms_amitim', herkev_hazmana.ms_amit.toString());
        params.set('ms_nilvim', herkev_hazmana.ms_nilve.toString());
        params.set('ms_yeladim', herkev_hazmana.ms_yeladim.toString());
        params.set('ms_tinokot', herkev_hazmana.ms_tinokot.toString());
        this._spinnerService.showSpinner();
        return this._http.get(`${this.apiUrl}/api/Nofesh/GetNofshonQuotationOnly`, { search: params })
            .pipe(
                tap(response => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .map((response: Response) => <INofshonPayment>response.json())
            .catch(this.handleError)
    }

    getNofshonQuotationOnlyNofeshPnim(herkev_hazmana: IHerkevHazmanaNofeshPnim): Observable<INofshonPayment> {
        //Used post since there are many parameters to send to the server. although the method name is "get".

        this._spinnerService.showSpinner();
        // return this._http.post(`${this.apiUrl}/api/Nofesh/GetNofshonQuotationOnlyNofeshPnim`,herkev_hazmana)

        // .map((response:Response) => <INofshonPayment>response.json())
        // .catch(this.handleError);

        return this._http.post(`${this.apiUrl}/api/Nofesh/GetNofshonQuotationOnlyNofeshPnim`, herkev_hazmana)
            .pipe(
                tap(response => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .map((response: Response) => <INofshonPayment>response.json())
            .catch(this.handleError)

        // return this._http.get(`${this.apiUrl}/api/Nofesh/GetNofshonQuotationOnly`, {search:params})
        // .pipe(
        //     tap(response => { this._spinnerService.hideSpinner(); },
        //         error => { this._spinnerService.hideSpinner(); }
        //     )
        // )
        // .map((response: Response) => <INofshonPayment>response.json())
        // .catch(this.handleError)
    }



    getNofshonUploads(nofeshId: number): Observable<INofeshUploads[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('nofeshId', nofeshId.toString());
        return this._http.get(`${this.apiUrl}/api/Nofesh/GetNofshonUploads`, { search: params })
            .map((response: Response) => <INofeshUploads[]>response.json())
            .catch(this.handleError)
    }

    getNofshonPriceType(id_nofesh: number): Observable<ResultOfOperation<number[]>> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('id_nofesh', id_nofesh.toString());
        this._spinnerService.showSpinner();
        return this._http.get(`${this.apiUrl}/api/Nofesh/GetNofshonPriceType`, { search: params })
            .pipe(
                tap(response => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .map((response: Response) => <ResultOfOperation<number[]>>response.json())
            .catch(this.handleError)
    }

    getCurrentTime(): Observable<ResultOfOperation<Date>> {
        this._spinnerService.showSpinner();

        return this._http.get(`${this.apiUrl}/api/Nofesh/GetCurrentTime`)
            .pipe(
                tap(response => { this._spinnerService.hideSpinner(); },
                    error => { this._spinnerService.hideSpinner(); }
                )
            )
            .map((response: Response) => <ResultOfOperation<Date>>response.json())
            .catch(this.handleError)
    }


    cancelNofshonReservation(id_nofesh: number): Observable<ResultOfOperation<boolean>> {
        this._spinnerService.showSpinner();

        const httpParams = new HttpParams()
            .set("nofeshId", id_nofesh.toString());
        const url = `${this.apiUrl}/api/Nofesh/CancelNofshonReservation`;
        return this._httpClient.get<ResultOfOperation<boolean>>(url, { params: httpParams })
            // cancelNofshonReservation(): Observable<ResultOfOperation<boolean>> {
            //     this._spinnerService.showSpinner();
            //     return this._httpClient.get<ResultOfOperation<boolean>>(`${this.apiUrl}/api/Nofesh/CancelNofshonReservation`)
            .pipe(
                tap((success: ResultOfOperation<boolean>) => {
                    if (!environment.production) console.log("Cancel nofshon reservation success", success);
                    this._spinnerService.hideSpinner();
                },
                    error => {
                        if (!environment.production) console.log("Cancel nofshon reservation error", error);
                        this._spinnerService.hideSpinner();
                    })
            );
    }

    clearSessionOnCancelReservation(nofeshId: number): void {
        let userSelectedNofesh: INofeshSelected = JSON.parse(sessionStorage.getItem("userSelectedNofesh"));
        if (userSelectedNofesh) {
            sessionStorage.removeItem("userSelectedNofesh");
            const { shem_prati, shem_mishpacha } = userSelectedNofesh;
            userSelectedNofesh = new NofeshSelected();
            userSelectedNofesh.shem_prati = shem_prati;
            userSelectedNofesh.shem_mishpacha = shem_mishpacha;
            sessionStorage.setItem("userSelectedNofesh", JSON.stringify(userSelectedNofesh));
        }
        sessionStorage.removeItem("moed-rishum");
        sessionStorage.removeItem("nofshon-nirshamim");
        sessionStorage.removeItem("nofshon-tashlumim");
        sessionStorage.removeItem(`pirteyNofshimVisited_${nofeshId}`);
    }



    private handleError(error: Response | any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);

            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        //console.error(errMsg);
        return Observable.throw(errMsg);
    }

}
